<template>
  <!-- MASTER FOOTER -->
  <footer class="master-footer">
    <!-- Title -->
    <h3 class="footer-title">Ealing Trailfinders Cricket Club</h3>

    <!-- Logo -->
    <figure class="py-4">
      <img src="../assets/img/logo-tfcc.svg" class="tfcc-logo" alt="TFCC" />
    </figure>

    <!-- Intro -->
    <div class="row justify-content-center">
      <div class="col-12 col-sm-10">
        <h1 class="intro-title">
          <span class="d-inline-block text-normal"
            >Cricket has been played on this ground for over</span
          >
          <span class="d-inline-block text-strong">100 years</span>
        </h1>
      </div>
    </div>

    <!-- Join Btn -->
    <div class="row justify-content-center py-3 py-lg-5">
      <div class="col-6 col-md-2">
        <a
          v-bind:href="'#/register?form=adult'"
          @click="scrollToTop"
          class="btn btn-tfcc-green btn-lg btn-block open-offCanvas"
          >Join Us
        </a>
      </div>
    </div>

    <ul class="nav justify-content-center">
      <!-- Social -->
      <li class="d-none">
        <a href="#" target="_blank" class=""
          ><i class="zmdi zmdi-instagram"
        /></a>
      </li>
      <li class="">
        <a
          href="https://www.facebook.com/groups/686811417998126"
          target="_blank"
          class=""
          ><i class="zmdi zmdi-facebook"
        /></a>
      </li>
      <li class="">
        <a
          href="https://twitter.com/trailfinderscc?lang=en"
          target="_blank"
          class=""
          ><i class="zmdi zmdi-twitter"
        /></a>
      </li>
      <!-- Contact -->
      <li class="">
        <a href="mailto:cricket@ealingtcc.com" class=""
          ><i class="material-icons">email</i></a
        >
      </li>
      <li class="">
        <a href="https://goo.gl/maps/1mtTgADiPDM2" target="_blank" class=""
          ><i class="material-icons">location_on</i></a
        >
      </li>
    </ul>

    <!-- Nav -->
    <ul class="nav justify-content-center my-4">
      <li class="nav-item">
        <a v-bind:href="'#/'" class="nav-link">Home</a>
      </li>
      <li class="nav-item">
        <a v-bind:href="'#/adults'" class="nav-link">Adults</a>
      </li>
      <li class="nav-item">
        <a v-bind:href="'#/juniors'" class="nav-link">Juniors</a>
      </li>
      <li class="nav-item">
        <a v-bind:href="'#/about'" class="nav-link">About</a>
      </li>
      <li class="nav-item">
        <a v-bind:href="'#/news'" class="nav-link">News</a>
      </li>
      <li class="nav-item">
        <a v-bind:href="'#/contact'" class="nav-link">Contact</a>
      </li>
      <li class="nav-item">
        <a href="#" @click="scrollToTop" class="nav-link btn-scroll"
          >Scroll Up</a
        >
      </li>
    </ul>

    <p class="text-white text-center text-small text-muted">
      &copy;{{ year }} Ealing Trailfinders Cricket Club
    </p>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style></style>
